export default __webpack_public_path__ + "static/media/newsletter.e013ec50.pdf";